import rajan from "../assets/teams/rajan.jpg";
import loki from "../assets/teams/loki.jpg";
import gita from "../assets/teams/gita.jpg";
import abhi from "../assets/partner/abhi.jpg";

export const items = [
  {
    img: abhi,
    name: "Abhi Mishra",
    work: "Founder",
    desc: "I must explain to you how all this idea of denouncing pleasure.",
  },
  {
    img: rajan,
    name: "Rajan Bahadur Shahi",
    work: "Fontend Developer Teacher.",
    desc: "He charms of pleasure of the moment, so blinded by desire foresee.",
  },
  {
    img: loki,
    name: "Lekendra Chaulagain",
    work: "Software Teacher.",
    desc: "To take a teachings, which of us ever undertakes physical exercise.",
  },

  {
    img: gita,
    name: "Gita Bista",
    work: "Dancer Teacher.",
    desc: "The actual teachings of the great explorer of the master-builder.",
  },
];
